// extracted by mini-css-extract-plugin
module.exports = {"header":"SG5A","icon":"O8Kb"};